import React from 'react';
import { SectionProps } from './Section.types';
import styled from 'threads5/styles/styled';
import { BackgroundContext } from 'src/contexts';
import Box from 'src/components-v2/Layout/Box/Box';
import SxProps from 'threads5/themes/sx-props';
import { ITheme } from 'threads5/themes/theme';

const forbiddenProps = new Set(['backgroundColor', 'bgColor', 'background']);
const shouldForwardProp = (prop: any): boolean => {
  return !forbiddenProps.has(prop);
};
const StyledSection = styled(Box, {
  shouldForwardProp,
})({});

const mapBackgroundValue = (
  backgroundColor: string | Partial<SxProps<ITheme>>,
  background: string | Partial<SxProps<ITheme>>,
  bgColor: string | Partial<SxProps<ITheme>>,
): string => {
  if (
    typeof backgroundColor === 'string' ||
    typeof background === 'string' ||
    typeof bgColor === 'string'
  ) {
    return (backgroundColor || background || bgColor || 'white') as string;
  }
  return 'white';
};

const Section = React.forwardRef<HTMLElement | any, SectionProps>(
  ({ children, component = 'section', sx, ...props }, ref) => {
    const { backgroundColor, bgColor, background, className, ...rest } = props;
    // we map the background value to a string because the BackgroundContext expects a string
    // bear in mind that we never pass background colors with breakpoints to the section component
    // this is only done to appease the typescript God's
    const bgValue = mapBackgroundValue(backgroundColor, background, bgColor);
    return (
      <BackgroundContext.Provider value={bgValue}>
        <StyledSection
          component={component}
          ref={ref}
          className={`cms-section ${className}`}
          {...rest}
        >
          {children}
        </StyledSection>
      </BackgroundContext.Provider>
    );
  },
);

export default styled(Section)({});
